import { jsx as t } from "react/jsx-runtime";
import { twMerge as n } from "tailwind-merge";
function m({ amount: e, className: r }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: n(
        "text-background-secondary bg-green flex min-h-6 min-w-6 items-center justify-center rounded-full p-1 text-xs",
        r
      ),
      children: e
    }
  );
}
export {
  m as AmountBadge
};
